define([
  "jquery"],
function ($) {

  "use strict";

  $(function() {
    $(".bdc-tabs").each(function() {
      $(this).height($(this).find("li:first").outerHeight() + $(this).find(".bdc-tabs-content:visible").outerHeight());
    });
    $("body").on("click", ".bdc-tabs-head", function() {
      var tabElement = $(this).closest(".bdc-tabs");
      tabElement.height($(this).next().outerHeight() + $(this).next().next().outerHeight());
    });
  });

});
